import styled from "styled-components";
export var Dialog = styled.div.withConfig({
  displayName: "cookieWarningstyles__Dialog",
  componentId: "sc-3pttlf-0"
})(["", ""], function (_ref) {
  var theme = _ref.theme;
  return "\n    background: ".concat(theme.colors.P1, ";\n    padding: 20px;\n    bottom: 0;\n    position: absolute;\n    left: 0;\n    right: 0;\n  ");
});